export {
  RegisterAccountSelectIDP,
  type RegisterAccountSelectIDPProps,
} from "~/components/RegisterAccountSelectIDP/RegisterAccountSelectIDP";
